<template>
    <div :class="{visible:show_menu, collapsed: !show_menu, 'top-menu-root':true}" :data-show-menu="show_menu">
        <div v-if="mobile" class="mobile-top-menu">
            <div class="mobile-menu-ribbon">
                <button class="btn cmd-main-menu" @click="showLeftMobileMenu">
                    <svg width="24px" height="24px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M4 18L20 18" stroke="#000000" stroke-width="2" stroke-linecap="round"/>
                        <path d="M4 12L20 12" stroke="#000000" stroke-width="2" stroke-linecap="round"/>
                        <path d="M4 6L20 6" stroke="#000000" stroke-width="2" stroke-linecap="round"/>
                    </svg>
                </button>
                <div class="flex-expand"></div>
                <slot name="header"></slot>
                <!-- <div>Infinite Education</div> -->
                <div class="flex-expand"></div>
                <button class="btn cmd-profile authorize" @click="showRightMobileMenu">
                    <img :src="data?.viewingUser?.avatar || '/static/images/no-avatar.jpg'" width="32" height="32" />
                </button>
            </div>
            <Teleport to="body">
                <template v-if="leftMobileMenuVisible">
                    <div class="mobile-menu-overlay" @click="showLeftMobileMenu"></div>
                </template> 

                <transition name="slide-left">
                    <template v-if="leftMobileMenuVisible">
                        <div class="mobile-menu left">
                            <div class="mobile-menu-scroller">
                                <div>
                                    <div class="close-container">
                                        <a href="/lk/about-games" class="logo">
                                            <img src="/static/images/logo/96.png" width="32" />
                                        </a>
                                        <button class="btn cmd-close" @click="showLeftMobileMenu"><span class="icon-close">&times;</span></button>    
                                    </div>
                        
                                    <mobile-menu-group :name="$t('Infinite Education')" :alwaysOpen="true">
                                        <mobile-menu-subgroup :name="$t('About project')" icon="/static/images/logo/48.png">
                                            <mobile-menu-subgroup-item :name="$t('Educational games')" url="/lk/about-games"/>
                                            <mobile-menu-subgroup-item :name="$t('Skillsets')" url="/lk/about-skillsets"/>
                                            <mobile-menu-subgroup-item :name="$t('Contacts')" url="/lk/contacts"/>
                                        </mobile-menu-subgroup>

                                        <mobile-menu-subgroup :name="$t('Events')" icon="/static/images/redisign/icons-top-menu/icon-left-menu-events-blue-24.png">
                                            <mobile-menu-subgroup-item :name="$t('Video')" url="/lk/activityExamples"/>
                                            <mobile-menu-subgroup-item :name="$t('Order event')" url="/lk/about-events"/>     
                                        </mobile-menu-subgroup>
                                    </mobile-menu-group>

                                    <mobile-menu-group :name="$t('Play & Learn')" :alwaysOpen="true">
                                        <mobile-menu-subgroup :name="$t('Create')" icon="/static/images/redisign/icons-top-menu/icon-create-all-blue-24.png">
                                            <mobile-menu-subgroup-item :name="$t('Game')" class="authorize" url="/lk/create-new/challenge"/>
                                            <mobile-menu-subgroup-item :name="$t('Task')" class="authorize" url="/edit-minigame/"/>
                                            <mobile-menu-subgroup-item :name="$t('Skillset')" class="authorize" url="/create-expertise"/>
                                            <mobile-menu-subgroup-item :name="$t('Course')" class="authorize" url="/create/course"/>
                                            <mobile-menu-subgroup-item :name="$t('Card deck')"  class="authorize" url="/lk/new-deck"/>
                                        </mobile-menu-subgroup>

                                        <mobile-menu-subgroup :name="$t('Catalog')" icon="/static/images/redisign/icons-top-menu/icon-infinity-blue-mobile-24.png">
                                            <mobile-menu-subgroup-item :name="$t('Games')" url="/catalog/challenges"/>
                                            <mobile-menu-subgroup-item :name="$t('Tasks')" url="/catalog/tasks"/>
                                            <mobile-menu-subgroup-item :name="$t('Skillsets')" url="/catalog/skillsets"/>
                                            <mobile-menu-subgroup-item :name="$t('Courses')" url="/catalog/courses"/>
                                            <mobile-menu-subgroup-item :name="$t('Study decks')" url="/catalog/cardlists"/>
                                        </mobile-menu-subgroup>

                                        <mobile-menu-subgroup :name="$t('For game authors')" icon="/static/images/redisign/icons-top-menu/icon-left-menu-authors-blue-24.png">
                                            <mobile-menu-subgroup-item :name="$t('How create task')" url="/lk/createTask"/>
                                            <mobile-menu-subgroup-item :name="$t('How create game')" url="/lk/createGame"/>
                                            <mobile-menu-subgroup-item :name="$t('How to play')" url="/lk/howToPlay"/>
                                            <mobile-menu-subgroup-item :name="$t('Play with AI & Friends')" url="/lk/playWithFriends"/>
                                            <mobile-menu-subgroup-item :name="$t('Team play')" url="/lk/teamPlay"/>
                                        </mobile-menu-subgroup>  
                                        
                                        <mobile-menu-subgroup :name="$t('For developers')" icon="/static/images/redisign/icons-top-menu/icon-code-blue-24.png">
                                            <mobile-menu-subgroup-item :name="$t('Integration')"  url="/lk/integration"/>
                                            <mobile-menu-subgroup-item :name="$t('Open API')" url="/lk/open-api"/>
                                        </mobile-menu-subgroup>

                                        <mobile-menu-group-item :name="$t('Join game')" icon="/static/images/redisign/icons-top-menu/joingame-mobile-gray-24.png" url="/lk/join-game"/>
                                    </mobile-menu-group>
                                    
                                    <mobile-menu-group :name="$t('Prices')" :alwaysOpen="true">
                                        <mobile-menu-group-item :name="$t('Prices')" url="/lk/about-plans" icon="/static/images/redisign/icons-top-menu/icon-left-menu-ruble-blue-24.png" />
                                    </mobile-menu-group>  
                                </div>

                                <mobile-menu-upgrede :name="$t('Upgrade')" url="/lk/about-plans"/>     
                            </div>
                        </div>
                    </template>
                </transition>

                <template v-if="rightMobileMenuVisible">
                    <div class="mobile-menu-overlay" @click="showRightMobileMenu"></div>
                </template>

                <transition name="slide-right">
                    <template v-if="rightMobileMenuVisible">
                        <div class="mobile-menu right">
                    
                            <button class="btn cmd-close" @click="showRightMobileMenu"><span class="icon-close">
                                <mobile-menu-text :name="username" :icon="data?.viewingUser?.avatar || '/static/images/no-avatar-48.jpg'"/>    
                            </span></button>

                            <mobile-menu-subgroup :name="$t('My content')" icon="/static/images/redisign/icons-top-menu/icon-my-content-blue-24.png">
                                <mobile-menu-subgroup-item :name="$t('Games')" url="/lk/myGames"/>
                                <mobile-menu-subgroup-item :name="$t('Tasks')" url="/lk/myTasks"/>
                                <mobile-menu-subgroup-item :name="$t('Skillsets')" url="/lk/mySkillsets"/>
                                <mobile-menu-subgroup-item :name="$t('Courses')" url="/lk/myCourses"/>
                                <mobile-menu-subgroup-item :name="$t('Study decks')" url="/lk/cardLists"/>
                            </mobile-menu-subgroup>

                            <mobile-menu-subgroup :name="$t('ImStuddy')" icon="/static/images/redisign/icons-top-menu/icon-i-learningl-blue-24.png">
                                <mobile-menu-subgroup-item :name="$t('Courses')" url="/lk/coursesIStudy"/>
                                <mobile-menu-subgroup-item :name="$t('Study decks')" url="/lk/userCardLists"/>
                                <mobile-menu-subgroup-item :name="$t('My skills')" url="/profile"/>
                            </mobile-menu-subgroup>

                            <mobile-menu-subgroup :name="$t('Profile')" icon="/static/images/redisign/icons-top-menu/icon-profile-blue-24.png">
                                <mobile-menu-subgroup-item :name="$t('View')" url="/profile" />
                                <mobile-menu-subgroup-item :name="$t('Edit')" url="/profile/edit"/>
                                <mobile-menu-subgroup-item :name="$t('Join game')" url="/lk/join-game"/>
                            </mobile-menu-subgroup>

                            <mobile-menu-subgroup :name="$t('Settings')" icon="/static/images/redisign/icons-top-menu/icon-settings-blue-24.png">
                                <mobile-menu-subgroup-item>
                                    <switch-language />
                                </mobile-menu-subgroup-item>
                            </mobile-menu-subgroup>

                            <mobile-menu-group-item :name="$t('Logout')" @click="logout" icon="/static/images/redisign/icons-top-menu/icon-logout-gray-24.png"/>
                        </div>
                    </template>
                </transition>
            </Teleport>
        </div>
        <div v-else :class="{'site-top-menu':true, 'flex-row': true}">
            <a href="/lk/about-games" class="logo">
                <img src="/static/images/logo/96.png" width="48" />
            </a>
            <div class="navigation-top-menu flex-expand flex-row">
                <!-- <div class='custom-menu'>
                    <slot></slot>
                </div> -->
                <div class="standard-menu flex-row flex-expand">
                    <top-menu-group :name="$t('Infinite Education')">
                        <top-menu-column>
                            <top-menu-subgroup :name="$t('About project')" icon="/static/images/logo/48.png">
                                <top-menu-subgroup-item :name="$t('Educational games')"  url="/lk/about-games" />
                                <top-menu-subgroup-item :name="$t('Skillsets')" url="/lk/about-skillsets"/>
                                <top-menu-subgroup-item :name="$t('Contacts')" url="/lk/contacts"/>
                            </top-menu-subgroup>

                            <top-menu-subgroup :name="$t('Events')" icon="/static/images/redisign/icons-top-menu/icon-left-menu-events-blue-24.png">
                                <top-menu-subgroup-item :name="$t('Video')" url="/lk/activityExamples"/>
                                <top-menu-subgroup-item :name="$t('Order event')" url="/lk/about-events"/>     
                            </top-menu-subgroup>
                        </top-menu-column>
                    </top-menu-group>

                    <top-menu-group :name="$t('Play & Learn')">
                        <top-menu-row>
                            <top-menu-subgroup :name="$t('Create')" icon="/static/images/redisign/icons-top-menu/icon-create-all-blue-24.png">
                                <top-menu-subgroup-item :name="$t('Game')" class="authorize" url="/lk/create-new/challenge"/>
                                <top-menu-subgroup-item :name="$t('Task')" class="authorize" url="/edit-minigame/"/>
                                <top-menu-subgroup-item :name="$t('Skillset')" class="authorize" url="/create-expertise"/>
                                <top-menu-subgroup-item :name="$t('Course')" class="authorize" url="/create/course"/>
                                <top-menu-subgroup-item :name="$t('Card deck')" class="authorize" url="/lk/new-deck"/>
                            </top-menu-subgroup>

                            <top-menu-subgroup :name="$t('Catalog')"  icon="/static/images/redisign/icons-top-menu/icon-infinity-blue-24.png">
                                <top-menu-subgroup-item :name="$t('Games')" url="/catalog/challenges"/>
                                <top-menu-subgroup-item :name="$t('Tasks')" url="/catalog/tasks"/>
                                <top-menu-subgroup-item :name="$t('Skillsets')" url="/catalog/skillsets" />
                                <top-menu-subgroup-item :name="$t('Courses')" url="/catalog/courses"/>
                                <top-menu-subgroup-item :name="$t('Study decks')" url="/catalog/cardlists"/>
                            </top-menu-subgroup>

                            <top-menu-vertical-line />

                            <top-menu-subgroup :name="$t('For game authors')" icon="/static/images/redisign/icons-top-menu/icon-left-menu-authors-blue-24.png">
                                <top-menu-subgroup-item :name="$t('How create task')" url="/lk/createTask"/>
                                <top-menu-subgroup-item :name="$t('How create game')" url="/lk/createGame" />
                                <top-menu-subgroup-item :name="$t('How to play')" url="/lk/howToPlay"/>
                                <top-menu-subgroup-item :name="$t('Play with AI & Friends')" url="/lk/playWithFriends"/>
                                <top-menu-subgroup-item :name="$t('Team play')"  url="/lk/teamPlay"/>
                            </top-menu-subgroup>     
                            
                            <top-menu-subgroup :name="$t('For developers')" icon="/static/images/redisign/icons-top-menu/icon-code-blue-24.png">
                                <top-menu-subgroup-item :name="$t('Integration')" url="/lk/integration"/>
                                <top-menu-subgroup-item :name="$t('Open API')" url="/lk/open-api"/>
                            </top-menu-subgroup>
                        </top-menu-row>
                        
                        <top-menu-row>
                            <top-menu-group-item :name="$t('Prices')" icon="/static/images/redisign/icons-top-menu/price-gray-24.png" url="/lk/about-plans"/>
                            <top-menu-group-item :name="$t('Watch demo')" icon="/static/images/redisign/icons-top-menu/whatch-demo-gray-24.png" url="https://rutube.ru/video/33a646fdbb86bfd4cab5a778e6689851/?r=plwd"/> 
                            <top-menu-group-item :name="$t('Join game')" icon="/static/images/redisign/icons-top-menu/joingame-gray-24.png" url="/lk/join-game"/>
                            <top-menu-expander />
                            <top-menu-group-upgrade :name="$t('Upgrade')" :baseData="data" url="/lk/about-plans"/>  
                        </top-menu-row>
                    </top-menu-group>

                    <top-menu-item :name="$t('Prices')" url="/lk/about-plans"/> 

                    <top-menu-expander />

                    <top-menu-upgrade :name="$t('Upgrade')" :baseData="data" url="/lk/about-plans"/>

                    <top-menu-group :name="username" class="authorize">
                        <template #content>
                            <template v-if="data?.viewingUser">
                                <img :src="data.viewingUser.avatar || '/static/images/no-avatar.jpg'" class="user-avatar" width="32" height="32" />
                                <span>{{ data.viewingUser.visualName }}</span>
                            </template>
                            <template v-else>
                                <!--<img src="/static/images/no-avatar.jpg" class="user-avatar" width="32" height="32" />-->
                                {{ $t('ANONIM') }}
                            </template>
                        </template>
                        <top-menu-column>
                            <top-menu-subgroup :name="$t('My content')" icon="/static/images/redisign/icons-top-menu/icon-my-content-blue-24.png">
                                <top-menu-subgroup-item :name="$t('Games')" url="/lk/myGames"/>
                                <top-menu-subgroup-item :name="$t('Tasks')" url="/lk/myTasks"/>
                                <top-menu-subgroup-item :name="$t('Skillsets')" url="/lk/mySkillsets"/>
                                <top-menu-subgroup-item :name="$t('Courses')" url="/lk/myCourses"/>
                                <top-menu-subgroup-item :name="$t('Study decks')" url="/lk/cardLists"/>
                            </top-menu-subgroup>

                            <top-menu-subgroup :name="$t('ImStuddy')" icon="/static/images/redisign/icons-top-menu/icon-i-learningl-blue-24.png">
                                <top-menu-subgroup-item :name="$t('Courses')" url="/lk/coursesIStudy"/>
                                <top-menu-subgroup-item :name="$t('Study decks')" url="/lk/userCardLists"/>
                                <top-menu-subgroup-item :name="$t('My skills')"  url="/profile"/>
                            </top-menu-subgroup>

                            <top-menu-subgroup :name="$t('Profile')" icon="/static/images/redisign/icons-top-menu/icon-profile-blue-24.png">
                                <top-menu-subgroup-item :name="$t('View')" url="/profile" />
                                <top-menu-subgroup-item :name="$t('Edit')" url="/profile/edit"/>
                                <top-menu-subgroup-item :name="$t('Join game')" url="/lk/join-game"/>
                            </top-menu-subgroup>

                            <top-menu-subgroup :name="$t('Settings')" icon="/static/images/redisign/icons-top-menu/icon-settings-blue-24.png">
                                <top-menu-subgroup-item>
                                    <switch-language />
                                </top-menu-subgroup-item>
                            </top-menu-subgroup>
                        
                            <top-menu-group-logout :name="$t('Logout')" @click="logout" icon="/static/images/redisign/icons-top-menu/icon-logout-gray-24.png"/>
                        </top-menu-column>
                    </top-menu-group>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import SwitchLanguage from '@root/components/switch-language.vue';
import i18n from '@root/components/i18n';
import MenuItem from './menu_item.vue';
import Api from '@root/components/api';
import Avatar from '@root/components/avatar_with_skills.vue';
import JoinGameBlock from '@root/course/join_game_block.vue';
import TopMenuGroup from '@root/course/top_menu_group.vue';
import TopMenuSubgroup from '@root/course/top_menu_subgroup.vue';
import TopMenuRow from '@root/course/top_menu_row.vue';
import TopMenuColumn from '@root/course/top_menu_column.vue';
import TopMenuSubgroupItem from '@root/course/top_menu_subgroup_item.vue';
import TopMenuItem from '@root/course/top_menu_item.vue';
import TopMenuUpgrade from '@root/course/top_menu_upgrade.vue';
import TopMenuGroupItem from '@root/course/top_menu_group_item.vue';
import TopMenuGroupLogout from '@root/course/top_menu_group_logout.vue';
import TopMenuGroupUpgrade from '@root/course/top_menu_group_upgrade.vue';
import TopMenuExpander from '@root/course/top_menu_expander.vue';
import TopMenuVerticalLine from '@root/course/top_menu_vertical_line.vue';

import MobileMenuGroup from '@root/course/mobile_menu_group.vue';
import MobileMenuGroupItem from '@root/course/mobile_menu_group_item.vue';
import MobileMenuSubgroup from '@root/course/mobile_menu_subgroup.vue';
import MobileMenuSubgroupItem from '@root/course/mobile_menu_subgroup_item.vue';
import MobileMenuUpgrede from '@root/course/mobile_menu_upgrade.vue';
import MobileMenuText from '@root/course/mobile_menu_text.vue';

const pathGroups = {
    "/catalog/skillsets": "catalog",
    "/catalog/courses": "catalog",
    "/catalog/challenges": "catalog",
    "/catalog/tasks": "catalog",
    "/catalog/lists": "catalog",
    "/catalog/cardlists": "catalog",

    "/lk/coursesIStudy": "imstudy",
    "/lk/userCardLists": "imstudy",
    "/profile": "imstudy",

    "/lk/mySkillsets": "my-content",
    "/lk/cardLists": "my-content",
    "/lk/myCourses": "my-content",
    "/lk/myGames": "my-content",
    "/lk/myTasks": "my-content",
    "/lk/new-deck": "my-content",
    "/lk/fieldSets": "my-content",
    "/lk/cardTemplates": "my-content",
    "/lk/cards": "my-content",

    "/lk/howToPlay": "for-game-authors",
    "/lk/playWithFriends": "for-game-authors",
    "/lk/howToOrganize": "for-game-authors",    
    "/lk/teamPlay": "for-game-authors",
    "/lk/createGame": "for-game-authors",
    "/lk/createTask": "for-game-authors",

    "/lk/orderActivity": "about-events",
    "/lk/activityExamples": "about-events",

    "/lk/open-api": "api",
    "/lk/integration": "api",

    "/lk/create-new/challenge": "create-new",
    //"/lk/create-new/template-challenge": "create-new",
    "/edit-minigame/": "create-new",
    "/lk/new-deck": "create-new",
    "/create/course": "create-new",
    //"/lk/create-new/ai-challenge": "create-new",

};

function removeLanguagePrefix(path) {
    if (path.length>4 && path[3] === '/' && path.indexOf("/lk/") !== 0) {
        return path.substring(3);
    }
    return path;
}

const pathname = removeLanguagePrefix(document.location.pathname);
const defaultTab = pathGroups[pathname] ?? '';
console.log("Default tab", defaultTab, pathname);

export default { 
    data: function() { 
        return {
            code: '',
            enterCode: false,
            tab: defaultTab,
            leftMobileMenuVisible: false,
            rightMobileMenuVisible: false,
        }        
    },
    props: ["data", "show_menu"],
    emits: ["show_menu", "close_menu"],
    components: {
        SwitchLanguage, MenuItem, Avatar, JoinGameBlock, 

        // top menu
        TopMenuItem, TopMenuUpgrade, TopMenuGroupLogout,
        TopMenuGroup, TopMenuGroupItem, TopMenuGroupUpgrade, 
        TopMenuSubgroup, TopMenuSubgroupItem, 
        TopMenuRow, TopMenuColumn, TopMenuExpander,  TopMenuVerticalLine,

        // mobile menu
        MobileMenuGroup, MobileMenuGroupItem, MobileMenuSubgroup, MobileMenuSubgroupItem, MobileMenuUpgrede, MobileMenuText,
    },
    mixins: [i18n],
    watch: {
        $route(to, from) {
            if (to.path != from.path) {
                //console.log(`$route`, from, to);
                //this.closeMenu();
            }
            this.refresh(0);
        },
        show_menu() {
            this.refresh(0);
        },
    },    
    computed: {
        username() {
            if (this.data?.viewingUser) {
                return this.data.viewingUser.visualName;
            } else {
                return this.$t("ANONIM");
            }
        },
        mobile() {
            const width = window.innerWidth;
            return width < 1399;
        },
    },
    created() {
    },
    mounted() {
        this.$nextTick(()=>{
            let as = document.querySelectorAll("a");
            as.forEach(a => {
                if (a.dataset.href === pathname) {
                    a.classList.add("router-link-exact-active");
                }
            });
        });
    },
    methods: {
        refresh(stage) {
            if(true)return;
            if (!stage) {
                window.dispatchEvent(new CustomEvent('mobile-menu-recalc-item', {}));            
            } else if (stage == 1) {
                window.dispatchEvent(new CustomEvent('mobile-menu-recalc-subgroup', {}));
            } else if (stage == 2) {
                window.dispatchEvent(new CustomEvent('mobile-menu-recalc-group', {}));
            } else {
                return;
            }

            this.$nextTick(()=>{this.refresh(+stage+1)});
        },
        // todo: code duplicate with switch-langauge.vue
        normalize(lang) {
            if (lang == 'en') 
                return 'gb';
            return lang;
        },        
        profile() {
            document.location = '/profile';
        },
        expand() {
            if (!this.show_menu) {
                this.$emit("show_menu");
            } else {
                this.$emit("close_menu");
            }
        },
        closeMenu() {
            this.$emit("close_menu");
        },
        showLeftMobileMenu() {
            this.leftMobileMenuVisible = !this.leftMobileMenuVisible;
        },
        showRightMobileMenu() {
            this.rightMobileMenuVisible = !this.rightMobileMenuVisible;
        },
        clickMenuGroup(name) {
            if (this.tab === name) {
                this.tab = '';
            } else {
                this.tab = name;
            }
        },        
        async logout() {
            await Api.logout();
            document.location.reload();
        },
        joinGame() {
            this.enterCode = true;
            this.$nextTick(()=>{
                this.$refs.code.focus();
            });
        },
        join() {
            const regex = /(\d{3})-?(\d{3})/;
            const parts = regex.exec(this.code);
            if (parts.length > 2) {
                const code = parts[1] + "-" + parts[2];
                document.location = "/join/" + code;
            }
        },
    }
}
</script>

<style lang="scss" scoped>
@import '@root/responsive';
.user-avatar {
    border-radius: 100px;
    padding: 2px;
    margin-right: 4px;
    position: relative;
    bottom: 1px;
}
.top-menu-root {
    display: flex;
    flex-direction: row;

    &.collapsed {
        display: none;
    }
}

.site-top-menu {
    display: flex;
    flex: 1 1;
    align-items: stretch;
    gap: 16px;
    height: 80px;
    background: white;
    padding: 0 16px;
    border-bottom: solid 1px #ebebeb;

    .logo {
        align-content: center;
        img {
            width: 48px;
            object-fit: contain;        
        }
    }
}

.navigation-top-menu {
    .custom-menu {

    }
    .standard-menu {
        align-items: stretch;
        justify-content: center;
        gap: 32px;
 
    }
}
.top-menu-group {
    //margin: 0 8px;
}

//mobile menu

.mobile-top-menu {
    flex: 1 1;
    flex-direction: row;
}

.cmd-main-menu {
    &.expanded {
//        display: none;
    }

    &.collapsed {
  //      display: flex;
    }
}

.mobile-menu-ribbon {
    flex: 1 1;
    height: 44px;
    display: flex;
    flex-direction: row;
    background: white;
    border-bottom: solid 1px #ebebeb;
    .btn:focus {box-shadow: none;}

    .cmd-profile {
        img {
            border-radius: 100px;
            padding: 2px;
            position: relative;
            bottom: 2px;
        }
    }
}

.mobile-menu-overlay {
    position: fixed;
    left: 0;
    top: 0;
    bottom: 0;
    right: 0;
    z-index: 998;
    background: rgba(0,0,0,0.2);
}

.mobile-menu {
    display: flex;
    flex-direction: column;
    position: fixed;
    left: 0;
    top: 0;
    bottom: 0;
    z-index: 998;
    background: white;
    min-width: 65vw;
    //padding: 16px;
    //padding-top: 80px;
    //border: solid 1px #ebebeb;
    //box-shadow: 4px 0 4px #ebebeb;
    overflow: auto;
    overflow-x: hidden;

    .close-container {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        height: 43px;
        //border-bottom: solid 1px #ebebeb;
        padding: 2px 0 2px 12px;
        .btn:focus {box-shadow: none;}
        .cmd-close {
            font-size: 24px;
            border: none;
            line-height: 1;
        }    
    }
    
    &.right {
        left: auto;
        right: 0;

        .cmd-close {
            background: #6179E0;
            color: white;
            position: relative;
            border-radius: 0;
            text-align: left;
            padding: 16px 12px;
        }
        .cmd-close::before {
            content: "";
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='370' height='185' viewBox='0 0 1600 800'%3E%3Cpath fill='%239FFF98' d='M1102.5 734.8c2.5-1.2 24.8-8.6 25.6-7.5.5.7-3.9 23.8-4.6 24.5C1123.3 752.1 1107.5 739.5 1102.5 734.8zM1226.3 229.1c0-.1-4.9-9.4-7-14.2-.1-.3-.3-1.1-.4-1.6-.1-.4-.3-.7-.6-.9-.3-.2-.6-.1-.8.1l-13.1 12.3c0 0 0 0 0 0-.2.2-.3.5-.4.8 0 .3 0 .7.2 1 .1.1 1.4 2.5 2.1 3.6 2.4 3.7 6.5 12.1 6.5 12.2.2.3.4.5.7.6.3 0 .5-.1.7-.3 0 0 1.8-2.5 2.7-3.6 1.5-1.6 3-3.2 4.6-4.7 1.2-1.2 1.6-1.4 2.1-1.6.5-.3 1.1-.5 2.5-1.9C1226.5 230.4 1226.6 229.6 1226.3 229.1zM33 770.3C33 770.3 33 770.3 33 770.3c0-.7-.5-1.2-1.2-1.2-.1 0-.3 0-.4.1-1.6.2-14.3.1-22.2 0-.3 0-.6.1-.9.4-.2.2-.4.5-.4.9 0 .2 0 4.9.1 5.9l.4 13.6c0 .3.2.6.4.9.2.2.5.3.8.3 0 0 .1 0 .1 0 7.3-.7 14.7-.9 22-.6.3 0 .7-.1.9-.3.2-.2.4-.6.4-.9C32.9 783.3 32.9 776.2 33 770.3z'/%3E%3Cpath fill='%23FFBBBA' d='M171.1 383.4c1.3-2.5 14.3-22 15.6-21.6.8.3 11.5 21.2 11.5 22.1C198.1 384.2 177.9 384 171.1 383.4zM596.4 711.8c-.1-.1-6.7-8.2-9.7-12.5-.2-.3-.5-1-.7-1.5-.2-.4-.4-.7-.7-.8-.3-.1-.6 0-.8.3L574 712c0 0 0 0 0 0-.2.2-.2.5-.2.9 0 .3.2.7.4.9.1.1 1.8 2.2 2.8 3.1 3.1 3.1 8.8 10.5 8.9 10.6.2.3.5.4.8.4.3 0 .5-.2.6-.5 0 0 1.2-2.8 2-4.1 1.1-1.9 2.3-3.7 3.5-5.5.9-1.4 1.3-1.7 1.7-2 .5-.4 1-.7 2.1-2.4C596.9 713.1 596.8 712.3 596.4 711.8zM727.5 179.9C727.5 179.9 727.5 179.9 727.5 179.9c.6.2 1.3-.2 1.4-.8 0-.1 0-.2 0-.4.2-1.4 2.8-12.6 4.5-19.5.1-.3 0-.6-.2-.8-.2-.3-.5-.4-.8-.5-.2 0-4.7-1.1-5.7-1.3l-13.4-2.7c-.3-.1-.7 0-.9.2-.2.2-.4.4-.5.6 0 0 0 .1 0 .1-.8 6.5-2.2 13.1-3.9 19.4-.1.3 0 .6.2.9.2.3.5.4.8.5C714.8 176.9 721.7 178.5 727.5 179.9zM728.5 178.1c-.1-.1-.2-.2-.4-.2C728.3 177.9 728.4 178 728.5 178.1z'/%3E%3Cg fill-opacity='0.49' fill='%23FFF'%3E%3Cpath d='M699.6 472.7c-1.5 0-2.8-.8-3.5-2.3-.8-1.9 0-4.2 1.9-5 3.7-1.6 6.8-4.7 8.4-8.5 1.6-3.8 1.7-8.1.2-11.9-.3-.9-.8-1.8-1.2-2.8-.8-1.7-1.8-3.7-2.3-5.9-.9-4.1-.2-8.6 2-12.8 1.7-3.1 4.1-6.1 7.6-9.1 1.6-1.4 4-1.2 5.3.4 1.4 1.6 1.2 4-.4 5.3-2.8 2.5-4.7 4.7-5.9 7-1.4 2.6-1.9 5.3-1.3 7.6.3 1.4 1 2.8 1.7 4.3.5 1.1 1 2.2 1.5 3.3 2.1 5.6 2 12-.3 17.6-2.3 5.5-6.8 10.1-12.3 12.5C700.6 472.6 700.1 472.7 699.6 472.7zM740.4 421.4c1.5-.2 3 .5 3.8 1.9 1.1 1.8.4 4.2-1.4 5.3-3.7 2.1-6.4 5.6-7.6 9.5-1.2 4-.8 8.4 1.1 12.1.4.9 1 1.7 1.6 2.7 1 1.7 2.2 3.5 3 5.7 1.4 4 1.2 8.7-.6 13.2-1.4 3.4-3.5 6.6-6.8 10.1-1.5 1.6-3.9 1.7-5.5.2-1.6-1.4-1.7-3.9-.2-5.4 2.6-2.8 4.3-5.3 5.3-7.7 1.1-2.8 1.3-5.6.5-7.9-.5-1.3-1.3-2.7-2.2-4.1-.6-1-1.3-2.1-1.9-3.2-2.8-5.4-3.4-11.9-1.7-17.8 1.8-5.9 5.8-11 11.2-14C739.4 421.6 739.9 421.4 740.4 421.4zM261.3 590.9c5.7 6.8 9 15.7 9.4 22.4.5 7.3-2.4 16.4-10.2 20.4-3 1.5-6.7 2.2-11.2 2.2-7.9-.1-12.9-2.9-15.4-8.4-2.1-4.7-2.3-11.4 1.8-15.9 3.2-3.5 7.8-4.1 11.2-1.6 1.2.9 1.5 2.7.6 3.9-.9 1.2-2.7 1.5-3.9.6-1.8-1.3-3.6.6-3.8.8-2.4 2.6-2.1 7-.8 9.9 1.5 3.4 4.7 5 10.4 5.1 3.6 0 6.4-.5 8.6-1.6 4.7-2.4 7.7-8.6 7.2-15-.5-7.3-5.3-18.2-13-23.9-4.2-3.1-8.5-4.1-12.9-3.1-3.1.7-6.2 2.4-9.7 5-6.6 5.1-11.7 11.8-14.2 19-2.7 7.7-2.1 15.8 1.9 23.9.7 1.4.1 3.1-1.3 3.7-1.4.7-3.1.1-3.7-1.3-4.6-9.4-5.4-19.2-2.2-28.2 2.9-8.2 8.6-15.9 16.1-21.6 4.1-3.1 8-5.1 11.8-6 6-1.4 12 0 17.5 4C257.6 586.9 259.6 588.8 261.3 590.9z'/%3E%3Ccircle cx='1013.7' cy='153.9' r='7.1'/%3E%3Ccircle cx='1024.3' cy='132.1' r='7.1'/%3E%3Ccircle cx='1037.3' cy='148.9' r='7.1'/%3E%3Cpath d='M1508.7 297.2c-4.8-5.4-9.7-10.8-14.8-16.2 5.6-5.6 11.1-11.5 15.6-18.2 1.2-1.7.7-4.1-1-5.2-1.7-1.2-4.1-.7-5.2 1-4.2 6.2-9.1 11.6-14.5 16.9-4.8-5-9.7-10-14.7-14.9-1.5-1.5-3.9-1.5-5.3 0-1.5 1.5-1.5 3.9 0 5.3 4.9 4.8 9.7 9.8 14.5 14.8-1.1 1.1-2.3 2.2-3.5 3.2-4.1 3.8-8.4 7.8-12.4 12-1.4 1.5-1.4 3.8 0 5.3 0 0 0 0 0 0 1.5 1.4 3.9 1.4 5.3-.1 3.9-4 8.1-7.9 12.1-11.7 1.2-1.1 2.3-2.2 3.5-3.3 4.9 5.3 9.8 10.6 14.6 15.9.1.1.1.1.2.2 1.4 1.4 3.7 1.5 5.2.2C1510 301.2 1510.1 298.8 1508.7 297.2zM327.6 248.6l-.4-2.6c-1.5-11.1-2.2-23.2-2.3-37 0-5.5 0-11.5.2-18.5 0-.7 0-1.5 0-2.3 0-5 0-11.2 3.9-13.5 2.2-1.3 5.1-1 8.5.9 5.7 3.1 13.2 8.7 17.5 14.9 5.5 7.8 7.3 16.9 5 25.7-3.2 12.3-15 31-30 32.1L327.6 248.6zM332.1 179.2c-.2 0-.3 0-.4.1-.1.1-.7.5-1.1 2.7-.3 1.9-.3 4.2-.3 6.3 0 .8 0 1.7 0 2.4-.2 6.9-.2 12.8-.2 18.3.1 12.5.7 23.5 2 33.7 11-2.7 20.4-18.1 23-27.8 1.9-7.2.4-14.8-4.2-21.3l0 0C347 188.1 340 183 335 180.3 333.6 179.5 332.6 179.2 332.1 179.2zM516.3 60.8c-.1 0-.2 0-.4-.1-2.4-.7-4-.9-6.7-.7-.7 0-1.3-.5-1.4-1.2 0-.7.5-1.3 1.2-1.4 3.1-.2 4.9 0 7.6.8.7.2 1.1.9.9 1.6C517.3 60.4 516.8 60.8 516.3 60.8zM506.1 70.5c-.5 0-1-.3-1.2-.8-.8-2.1-1.2-4.3-1.3-6.6 0-.7.5-1.3 1.2-1.3.7 0 1.3.5 1.3 1.2.1 2 .5 3.9 1.1 5.8.2.7-.1 1.4-.8 1.6C506.4 70.5 506.2 70.5 506.1 70.5zM494.1 64.4c-.4 0-.8-.2-1-.5-.4-.6-.3-1.4.2-1.8 1.8-1.4 3.7-2.6 5.8-3.6.6-.3 1.4 0 1.7.6.3.6 0 1.4-.6 1.7-1.9.9-3.7 2-5.3 3.3C494.7 64.3 494.4 64.4 494.1 64.4zM500.5 55.3c-.5 0-.9-.3-1.2-.7-.5-1-1.2-1.9-2.4-3.4-.3-.4-.7-.9-1.1-1.4-.4-.6-.3-1.4.2-1.8.6-.4 1.4-.3 1.8.2.4.5.8 1 1.1 1.4 1.3 1.6 2.1 2.6 2.7 3.9.3.6 0 1.4-.6 1.7C500.9 55.3 500.7 55.3 500.5 55.3zM506.7 55c-.3 0-.5-.1-.8-.2-.6-.4-.7-1.2-.3-1.8 1.2-1.7 2.3-3.4 3.3-5.2.3-.6 1.1-.9 1.7-.5.6.3.9 1.1.5 1.7-1 1.9-2.2 3.8-3.5 5.6C507.4 54.8 507.1 55 506.7 55zM1029.3 382.8c-.1 0-.2 0-.4-.1-2.4-.7-4-.9-6.7-.7-.7 0-1.3-.5-1.4-1.2 0-.7.5-1.3 1.2-1.4 3.1-.2 4.9 0 7.6.8.7.2 1.1.9.9 1.6C1030.3 382.4 1029.8 382.8 1029.3 382.8zM1019.1 392.5c-.5 0-1-.3-1.2-.8-.8-2.1-1.2-4.3-1.3-6.6 0-.7.5-1.3 1.2-1.3.7 0 1.3.5 1.3 1.2.1 2 .5 3.9 1.1 5.8.2.7-.1 1.4-.8 1.6C1019.4 392.5 1019.2 392.5 1019.1 392.5zM1007.1 386.4c-.4 0-.8-.2-1-.5-.4-.6-.3-1.4.2-1.8 1.8-1.4 3.7-2.6 5.8-3.6.6-.3 1.4 0 1.7.6.3.6 0 1.4-.6 1.7-1.9.9-3.7 2-5.3 3.3C1007.7 386.3 1007.4 386.4 1007.1 386.4zM1013.5 377.3c-.5 0-.9-.3-1.2-.7-.5-1-1.2-1.9-2.4-3.4-.3-.4-.7-.9-1.1-1.4-.4-.6-.3-1.4.2-1.8.6-.4 1.4-.3 1.8.2.4.5.8 1 1.1 1.4 1.3 1.6 2.1 2.6 2.7 3.9.3.6 0 1.4-.6 1.7C1013.9 377.3 1013.7 377.3 1013.5 377.3zM1019.7 377c-.3 0-.5-.1-.8-.2-.6-.4-.7-1.2-.3-1.8 1.2-1.7 2.3-3.4 3.3-5.2.3-.6 1.1-.9 1.7-.5.6.3.9 1.1.5 1.7-1 1.9-2.2 3.8-3.5 5.6C1020.4 376.8 1020.1 377 1019.7 377zM1329.7 573.4c-1.4 0-2.9-.2-4.5-.7-8.4-2.7-16.6-12.7-18.7-20-.4-1.4-.7-2.9-.9-4.4-8.1 3.3-15.5 10.6-15.4 21 0 1.5-1.2 2.7-2.7 2.8 0 0 0 0 0 0-1.5 0-2.7-1.2-2.7-2.7-.1-6.7 2.4-12.9 7-18 3.6-4 8.4-7.1 13.7-8.8.5-6.5 3.1-12.9 7.4-17.4 7-7.4 18.2-8.9 27.3-10.1l.7-.1c1.5-.2 2.9.9 3.1 2.3.2 1.5-.9 2.9-2.3 3.1l-.7.1c-8.6 1.2-18.4 2.5-24 8.4-3 3.2-5 7.7-5.7 12.4 7.9-1 17.7 1.3 24.3 5.7 4.3 2.9 7.1 7.8 7.2 12.7.2 4.3-1.7 8.3-5.2 11.1C1335.2 572.4 1332.6 573.4 1329.7 573.4zM1311 546.7c.1 1.5.4 3 .8 4.4 1.7 5.8 8.7 14.2 15.1 16.3 2.8.9 5.1.5 7.2-1.1 2.7-2.1 3.2-4.8 3.1-6.6-.1-3.2-2-6.4-4.8-8.3C1326.7 547.5 1317.7 545.6 1311 546.7z'/%3E%3C/g%3E%3C/svg%3E");
            background-repeat: repeat;
            background-size: 60%;
            background-position: center;
            z-index: 0;
            
        }
    }
}

.mobile-menu-scroller {
    display: flex;
    flex-direction: column;
    position: relative;
    justify-content: space-between;
    flex: 1 1;
}

.slide-left-enter-active, .slide-left-leave-active {
  opacity: 1;
  transform: translateX(0%);
  transition: opacity 0.4s ease, transform 0.4s ease;
}

.slide-left-enter-from, .slide-left-leave-to {
    opacity: 0;
    transform: translateX(-100%);
}

.slide-right-enter-active, .slide-right-leave-active {
  opacity: 1;
  transform: translateX(0%);
  transition: opacity 0.4s ease, transform 0.4s ease;
}

.slide-right-enter-from, .slide-right-leave-to {
    opacity: 0;
    transform: translateX(100%);
}

</style>


<i18n>
{
    en: {
        ANONIM: "Login",
        "ImStuddy":"I'm study",
    },
    ru: {
        ANONIM: "Вход",
        Logout: "Выйти",

        "Infinite Education":"Бесконечное образование",
        "About project":"О проекте",
        "Educational games":"Обучающие игры",
        "Skillsets": "Скиллсеты",
        "Events":"Мероприятия",
        "Video":"Видео",
        "Order event":"Заказать у нас",
        "Play & Learn":"Играй и учись",
        "Create": "Создать",
        "Game": "Игру",
        "Task": "Задание",
        "Skillset":"Скиллсет",
        "Course":"Курс",
        "Card deck": "Колоду карточек",
        "Catalog":"Каталог",
        "Games": "Игры",
        "Tasks":"Задания",
        "Skillsets":"Скиллсеты",
        "Contacts":"Контакты",
        "Courses":"Курсы",
        "Study decks":"Колоды для повторения",
        "For game authors": "Авторам игр",
        "How create task": "Как создать задание",
        "How create game": "Как создать игру",
        "How to play": "Как играть",
        "Play with AI & Friends": "Играть с ИИ/друзьями",
        "Team play": "Командная игра",
        "For developers": "Разработчикам",
        "Integration": "Интеграция",
        "Open API": "Открытое API",
        "Prices":"Цены",
        "Watch demo":"Смотрите демо",
        "Upgrade":"Улучшить",
        "My content":"Мой контент",
        "ImStuddy":"Я учу",
        "My skills": "Мои навыки",
        "Profile":"Профиль",
        "View":"Просмотр",
        "Edit":"Редактировать",
        "Join game":"Присоединиться к игре",
        "Settings": "Настройки",
        "Logout":"Выйти",
        "Login":"Войти",
        
        "":"",
        "":"",
        "":"",
        "":"",




        
        
        
        
        "order Activity": "Заказать у нас",

        "howToOrganize": "Как организовывать",
        
        
       
        
        
        
       
        Logout: "Выйти",
        
        Code: "Код",
        EnterCode: "000-000",
        Join: "Вперёд",
     
       
        
        
        
    
        "Practice": "Практика",
        
        "Challenges": "Игры",
        
        
    
        
        "Game from template": "Игру из шаблона",
        
        
        
        "Generate game": "Генерировать игру с ИИ",
        
    }
}
</i18n>